var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CButton',{attrs:{"icon":_vm.ciCarcheck,"variant":"primary"},on:{"click":function($event){return _vm.$emit('make-new-request')}}},[_vm._v(_vm._s(_vm.$t('new ticket::audits')))])}
var staticRenderFns = []

export { render, staticRenderFns }